import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_teams.breadcrumb.teams_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_teams.breadcrumb.teams_label2'),
    link: '/application/championships',
  },
  {
    label: t('pages.application_teams.breadcrumb.teams_label3'),
  },
];
